export enum QueryKeys {
  GET_INSURANCE_PRODUCT = 'petsTelevetPlusGetInsuranceProduct',
  GET_PETS_INFO = 'petsTelevetPlusGetPetsInfo',
  GET_INSURANCE_LIMIT_START = 'petsTelevetPlusGetInsuranceLimitStart',
  GET_PRICES_FULL = 'petsTelevetPlusGetPricesFull',
  GET_INSURANCE_PROGRAMS = 'petsTelevetPlusGetInsurancePrograms',
  GET_INSURANCE_PROGRAMS_PRICES = 'petsTelevetPlusGetInsuranceProgramsPrices',
}
